import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VhpData from "../data/vpsHostingPlans.json";

const VhpPage = () => {
  const [pageData, setPageData] = useState({});
    useEffect(() => {
        if (VhpData?.VpsHostingPlans?.length > 0) {
        setPageData(VhpData.VpsHostingPlans[0]);
        }
    }, []);
    if (!pageData) return <p>Loading...</p>;

  return (
    <>
        <div className="page-title">
          <div className="container py-5">
            <h2 className="title position-relative">{pageData.title}</h2>
          </div>
        </div>

        <section className="product-section vps-hosting">
          <div className="container">
            <div className="row">
                <div className="col">
                    <div className="section-title text-center">
                        <h2>{pageData.subTitle}</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                {pageData?.Plans?.length > 0 &&
                    pageData.Plans.map((product, idc) => (
              <div key={idc} className="col-lg-3 col-md-6 col-sm-6 my-5">
                <div className="product-card">
                    <div className="clean-pricing-item">
                        
                        {/* <div className="ribbon"><span>{product.ribbon}</span></div> */}

                        <table className="table table-bordered pricing-table text-center">
                            <thead>
                                    <tr>
                                    <td><h4>{product.title}</h4><span className="price">{product.price}</span> /mo.<br />{product.setup}<br /><a className="text-light btn btn-custom btn-lg" href={product.order_link}>Order Now</a></td>
                                    </tr>
                                    <tr>
                                    {/* <td><h5>{product.description}</h5></td> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.features.map((feature, i) => (
                                        <tr key={i}>
                                        <td>{feature}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td><p className="mb-0">Enhance your data protection with our backup services</p><a className="toggle collapsed" data-bs-toggle="collapse" href={`#collapseC${idc}`} aria-expanded="false" aria-controls={`collapseC${idc}`}>Backup Options (Optional)<i className="fa fa-caret-down"></i></a></td>
                                    </tr>
                                </tfoot>
                        </table>

                        <div className="collapse" id={`collapseC${idc}`} aria-expanded="false"> 
                            <table className="table table-bordered text-center table-collapsable">
                            <tbody>
                                {product.addons.map((addon, i) => (
                                    <tr key={i}>
                                        <td>
                                        <strong>{addon.title}</strong>
                                        <br />
                                        {addon.details}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>

                    </div>
                </div>
              </div>
              ))}
              {/*colend*/}
            </div>

            <div className="row">
              <div className="col">
                <div className="txt-wrap py-3">
                <div class="section-title">
                  <h4 className="mb-3">What’s Included in Your Setup Fee?</h4>
                  <ul className="product-features">
                    <li><i class="fa fa-check"></i>&nbsp;VPS provisioned from optimized Proxmox template.</li>
                    <li><i class="fa fa-check"></i>&nbsp;Private IP and dedicated public IPv4 address assignment.</li>
                    <li><i class="fa fa-check"></i>&nbsp;pfSense firewall configured with custom NAT and port forwards based on your requirements.</li>
                    <li><i class="fa fa-check"></i>&nbsp;OS configuration and initial security hardening.</li>
                    <li><i class="fa fa-check"></i>&nbsp;One hour of expert setup and testing.</li>
                  </ul>
                  </div>
                  </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="txt-wrap pb-3">
                    <div class="section-title">
                      <h4 className="mb-3">Additional Information / Notes</h4>
                      <ul className="product-features">
                        <li><i class="fa fa-arrow-right"></i>&nbsp;All VPSes come with shared 500 Mbps bandwidth included</li>
                        <li><i class="fa fa-arrow-right"></i>&nbsp;Firewall rules tailored to your needs; you control which ports are open.</li>
                        <li><i class="fa fa-arrow-right"></i>&nbsp;Additional public IPs or port forwards can be added upon request (contact us for pricing).</li>
                        <li><i class="fa fa-arrow-right"></i>&nbsp;Managed support and ongoing firewall rule updates are available as paid services.</li>
                      </ul>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </section>

    </>
  );
};

export default VhpPage;
